import { render, staticRenderFns } from "./cModalNewProducto.vue?vue&type=template&id=33198959"
import script from "./cModalNewProducto.vue?vue&type=script&lang=js"
export * from "./cModalNewProducto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports